@if (collector) {
    <div class="ws-flex-container-vertical ws-flex-auto">
        <ws-bread-crumbs [breadcrumbs]="breadcrumbs" [currentPageTitle]="collector.name"></ws-bread-crumbs>
        @if (collector) {
            <div class="row equal-panel" [ngClass]="{ 'remove-panel': isTaxRatesMaximized }">
                <div class="col-xl-4">
                    <collector-details [entityId]="entityId"
                                       [companyId]="companyId"
                                       [collectorValue]="collector"
                                       [viewOnly]="viewOnly"
                                       [isCompanyCollector]="isCompanyCollector">
                    </collector-details>
                </div>
                <div class="col-xl-8">
                    <billing-scenario [collector]="collector"
                                      (collectorUpdated)="refreshCollector()">
                    </billing-scenario>
                </div>
            </div>
        }
        @if (!isCompanyCollector) {
            <div class="row">
                <div class="col-xl-12">
                    <tax-rates-panel [collectorId]="collector.collectorID"
                                     [annualRateIncrease]="collector.annualRateIncrease"
                                     [assessorId]="collector.assessorID"
                                     (maximizeToggled)="toggleTaxRatesMaximize($event)">
                    </tax-rates-panel>
                </div>
            </div>
        }
        @if ((!isCompanyCollector || !viewOnly)) {
            <div class="row" [ngClass]="{ 'remove-panel': isTaxRatesMaximized }">
                <div class="col-xl-12">
                    <collector-protocols [collector]="collector"
                                         [canEdit]="!viewOnly">
                    </collector-protocols>
                </div>
            </div>
        }
        @if (!isCompanyCollector && entityProperties) {
            <div class="row" [ngClass]="{ 'remove-panel': isTaxRatesMaximized }">
                <div class="col-xl-12">
                    <contacts-panel [entity]="entityProperties"></contacts-panel>
                </div>
            </div>
        }
    </div>
}
